import { h, Component } from 'preact';
import RCPagination from 'rc-pagination';
import 'rc-pagination/assets/index.css';
import locale from 'rc-pagination/lib/locale/en_GB';

import style from './style.scss';


class Pagination extends Component {

  render({ current, total, pageSize, onChange }) {
    return (
      <div className={style.pagination}>
            <RCPagination locale={locale} nextIcon={'Next'} prevIcon={'Previous'} total={total} pageSize={pageSize} current={current} onChange={onChange} />
      </div>
    );
  }
}

export default Pagination;


// WEBPACK FOOTER //
// ./components/pagination/index.js